/* 设计变更单（Arcus 模版）表单数据：空模版 / 行小计 / 增减合计 / 变更后合同价（与后端 change_order_doc.derive 同一口径） */
export const num = (v) => { const n = parseFloat(String(v ?? "").replace(/[$,]/g, "")); return Number.isFinite(n) ? n : 0; };
const r2 = (n) => Math.round(n * 100) / 100;
export const fmtUSD = (v) => { const n = Number(v || 0); return (n < 0 ? "-" : "") + "$" + Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

export const CO_TYPES = [["add", "Add 新增"], ["delete", "Delete 删除"], ["revise", "Revise 修订"], ["substitute", "Substitute 替换"]];

export const emptyDoc = () => ({
  docNo: "", date: new Date().toISOString().slice(0, 10), projectAddress: "",
  contractor: { legalName: "", license: "", address: "", phone: "", email: "", contact: "" },
  owner: { name: "", phone: "", email: "" }, baseContract: { no: "", date: "" },
  types: { add: false, delete: false, revise: false, substitute: false },
  reason: "", revisedScope: "", exclusions: "", included: "", drawings: "",
  pricingBasis: "fixed", pricingOther: "", pricingNote: "", lines: [], priceBefore: 0, priorCredit: "", schedule: [],
  approxStart: "", completion: "", timeAdj: { mode: "none", days: 0 }, revisedCompletion: "", otherTerms: "",
  signatures: { contractorRep: "", contractorTitle: "", ownerName: "" },
});

export const newLine = (kind = "add") => ({ desc: "", qty: "", unit: "", unitPrice: "", amount: "", kind });

export const lineAmount = (l) => { const q = num(l.qty), u = num(l.unitPrice); return q && u ? r2(q * u) : r2(Math.abs(num(l.amount))); };

export function computeDoc(doc) {
  const lines = (doc.lines || []).map((l) => ({ ...l, computed: lineAmount(l) }));
  const additions = r2(lines.filter((l) => l.kind !== "credit").reduce((a, l) => a + l.computed, 0));
  const credits = r2(lines.filter((l) => l.kind === "credit").reduce((a, l) => a + l.computed, 0));
  const net = r2(additions - credits);
  const before = num(doc.priceBefore);
  return { lines, additions, credits, net, priceBefore: before, priceAfter: r2(before + net) };
}
